import React, { useState } from "react";
import "../../style/FaiDaTe/FaiDaTe.scss";
import { motion } from "framer-motion";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import { ReactComponent as FdtIcon } from "../../assets/new-icons/faiDaTeIcon.svg";
import Collapse from "../../components/FaiDaTe/Faq/Collapse";
import NewHeader from "../../components/New Header/NewHeader";
import Header from "../../components/Header in Page/_Header";

function Assistenza() {
  const navigate = useNavigate();
  const [showScroll, setShowScroll] = useState(false);
  const [next, setNext] = useState(0);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 120) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 120) {
      setShowScroll(false);
    }
  };
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  window.addEventListener("scroll", checkScrollTop);

  const bodyBox = {
    initial: {
      height: 0,
      bottom: -198,
      borderTopLeftRadius: "40px",
      borderTopRightRadius: "40px",
      transition: {
        duration: 1.0,
        ease: [0.87, 0, 0.13, 1],
      },
    },
    animate: {
      height: "90%",
      borderTopLeftRadius: next ? "0px" : "40px",
      borderTopRightRadius: next ? "0px" : "40px",
      bottom: next ? 0 : -198,
      transition: {
        duration: 1.0,
        ease: [0.87, 0, 0.13, 1],
      },
    },
  };

  return (
    <div className="faq">
      <div className="faq-top">
        <NewHeader logo="white" padding="no" iconsColor="white" />
      </div>
      <div className="faq-bottom">
        <Header
          title="FAQ"
          description={`Hai bisogno di aiuto?`}
          icon="faiDaTe"
        />
        <p className="info">
          Per trovare risposta a tutti i tuoi dubbi, per approfondire tutte le
          funzionalità della tua area personale e per scoprire tutti i dettagli
          dell'offerta Revoluce abbiamo realizzato un'area di Supporto tramite
          il portale Zendesk.
        </p>
        <p className="info">
          Qui troverai tanti articoli e video che ti aiuteranno a capire al
          meglio il funzionamento di ogni aspetto di Revoluce e ti guideranno
          passo dopo passo nelle procedure relative alla tua utenza.
        </p>
        <p className="info">
          All'interno del nostro Help Desk potrai trovare tante informazioni
          utili e sempre aggiornate.
        </p>
        <a href="https://revoluce.zendesk.com/hc/it" target="_blank">
          Vai all'Area di Supporto
        </a>
      </div>
    </div>
    // <div className={`faiDaTe ${showScroll ? 'noBack' : next === 1 || next === 2 || next === 3 ? 'noBack' : ''}`} onClick={() => scrollTop}>
    //     {next === 0 ? (
    //         <motion.div
    //             initial="initial"
    //             animate="animate"
    //             className={`header neutral
    //                 ${showScroll ? 'fixed' : ''}`
    //             }
    //         >
    //             <div className="navigation" onClick={() => navigate(-1)}>
    //                 <ArrowBackIcon/>
    //             </div>
    //             <div className="information">
    //                 <div style={{marginBottom: '30px'}} className="planName epilogue">
    //                     <FdtIcon/>
    //                 </div>
    //                 <div className="planDescription">
    //                     <p style={{fontSize: '18px'}}>Fai da te</p>
    //                 </div>
    //                 <div className="planName epilogue">
    //                     <p>Hai bisogno di aiuto?</p>
    //                 </div>
    //             </div>
    //         </motion.div>
    //     ) : (
    //         <motion.div
    //             initial="initial"
    //             animate="animate"
    //             className={`header green
    //                 ${showScroll ? 'fixed' : ''}`
    //             }
    //             style={{paddingLeft: '30px', paddingTop: '0px', paddingBottom: '0px', justifyContent: 'center', height: '9%'}}
    //         >

    //         </motion.div>
    //     )}
    //     <motion.div
    //         initial="initial"
    //         animate="animate"
    //         variants={bodyBox}
    //         className={`body ${showScroll ? 'noBorder' : ''}`}
    //     >
    //         <p className="info">
    //         Per trovare risposta a tutti i tuoi dubbi, per approfondire tutte le funzionalità della tua area personale e per scoprire tutti i dettagli dell'offerta Revoluce abbiamo realizzato un'area di Supporto tramite il portale Zendesk.
    //         </p>
    //         <p className='info'>
    //             Qui troverai tanti articoli e video che ti aiuteranno a capire al meglio il funzionamento di ogni aspetto di Revoluce e ti guideranno passo dopo passo nelle procedure relative alla tua utenza.
    //         </p>
    //         <p className='info'>
    //             All'interno del nostro Help Desk potrai trovare tante informazioni utili e sempre aggiornate.
    //         </p>
    //         <a href="https://revoluce.zendesk.com/hc/it" target='_blank'>Vai all'Area di Supporto</a>
    //         {/* <Collapse /> */}
    //     </motion.div>

    // </div>
  );
}

export default Assistenza;
